/** Filipino: Workflows, ang mga customer fact na mapipili sa condition (M29 PDI-006). */
export const workflowsCustomer = {
  conditionGroups: {
    customer: "Customer (naka-sign in)",
    customerAttributes: "Mga attribute ng customer (naka-sign in)",
  },
  conditionFields: {
    customer_tier: "Tier ng customer",
    customer_account_status: "Katayuan ng account ng customer",
    customer_verified_by: "Kinumpirma ng",
    customer_context_as_of: "Petsa ng datos ng customer",
  },
  conditionChoices: {
    customer_account_status: {
      active: "Aktibo",
      restricted: "May limitasyon",
      suspended: "Naka-suspend",
      self_excluded: "Nag-exclude sa sarili",
      closed: "Sarado",
      kyc_pending: "Naghihintay ng identity check",
    },
    customer_verified_by: { operator: "Ang system ng operator", staff: "Ang aming team" },
  },
} as const;
